import React from "react"
import InputComponent from '../components/InputComponent'
import Planet from '../components/Planet';
import Stars from '../components/Stars';
import Rocket from '../components/Rocket';
import TargetDisplay from '../components/targetdisplay';
import SixSigma from '../includes/sixsigma-logo-white.png'
import '../components/layout.css'
import { Helmet } from 'react-helmet';

const IndexPage = () => (
   <div>
      <Helmet>
          <title>Multi-Vari Exercise &ndash; Spaceship | 6Sigma.us</title>
      </Helmet>
       <div className= "sixsigma"><img src={SixSigma} width="150px" height="auto"/></div>
        <div className="galaxy-planets">
          <Planet />
        </div>
        <Stars/>
        <Rocket />
        <InputComponent />
        <TargetDisplay />
    </div>
)

export default IndexPage
